/* eslint-disable max-params */
/* eslint-disable complexity */
/* eslint-disable no-console */
import {constants} from './constants';

function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
}

const validate = (key, val, setError, errorMessage, formState) => {
    if (typeof val !== 'string' || typeof val === 'string' && val.trim().length <= 0) {
        setError(key, {
            message: errorMessage
        });
        formState.push(errorMessage);
    }

    if (key === constants.ERROR_MESSAGES.impactedUserEmail.fieldKey || key === constants.ERROR_MESSAGES.email.fieldKey) {
        if (!isValidEmail(val) && typeof val === 'string' && val.trim().length > 0) {
            setError(key, {
                message: 'Email Format is not valid. Ex : (test@test.com)'
            });
            formState.push(errorMessage);
        }
    }
};

export const verifyContactUsFormData = (data, setError) => {
    const formState = [];

    validate(constants.ERROR_MESSAGES.jdsnAppSelection.fieldKey, data.jdsnAppSelection, setError, constants.ERROR_MESSAGES.jdsnAppSelection.message, formState);

    for (const [key, val] of Object.entries(data.fields)) {
        switch (key) {
            case constants.ERROR_MESSAGES.userId.fieldKey : validate(key, val, setError, constants.ERROR_MESSAGES.userId.message, formState);
                break;
            case constants.ERROR_MESSAGES.userName.fieldKey : validate(key, val, setError, constants.ERROR_MESSAGES.userName.message, formState);
                break;
            case constants.ERROR_MESSAGES.email.fieldKey : validate(key, val, setError, constants.ERROR_MESSAGES.email.message, formState);
                break;
            case constants.ERROR_MESSAGES.comments.fieldKey : validate(key, val, setError, constants.ERROR_MESSAGES.comments.message, formState);
                break;
            case constants.ERROR_MESSAGES.impactedSupplierName.fieldKey : validate(key, val, setError, constants.ERROR_MESSAGES.impactedSupplierName.message, formState);
                break;
            case constants.ERROR_MESSAGES.impactedSupplierNumber.fieldKey : validate(key, val, setError, constants.ERROR_MESSAGES.impactedSupplierNumber.message, formState);
                break;
            case constants.ERROR_MESSAGES.impactedUserEmail.fieldKey : validate(key, val, setError, constants.ERROR_MESSAGES.impactedUserEmail.message, formState);
                break;
            case constants.ERROR_MESSAGES.impactedUserJobTitle.fieldKey : validate(key, val, setError, constants.ERROR_MESSAGES.impactedUserJobTitle.message, formState);
                break;
            case constants.ERROR_MESSAGES.impactedUserFirstName.fieldKey : validate(key, val, setError, constants.ERROR_MESSAGES.impactedUserFirstName.message, formState);
                break;
            case constants.ERROR_MESSAGES.impactedUserLastName.fieldKey : validate(key, val, setError, constants.ERROR_MESSAGES.impactedUserLastName.message, formState);
                break;
            case constants.ERROR_MESSAGES.impactedUserMiddleInit.fieldKey : validate(key, val, setError, constants.ERROR_MESSAGES.impactedUserMiddleInit.message, formState);
                break;
            case constants.ERROR_MESSAGES.customOption.fieldKey : validate(key, val, setError, constants.ERROR_MESSAGES.customOption.message, formState);
                break;
            default: break;
        }
    }

    return formState.length > 0;
};
